import { useState } from 'react';
import openAPIErrorNotification from '@/shared/APIErrorNotification/APIErrorNotification';
import createAndEnrollStudent from '@/api/enrollment/createAndEnrollStudent.endpoint';
import { capitalizeAllWords } from '@/modules/stringUtils';

export default function useCreateAndEnrollStudentStep({
  flowState,
  flowActions,
}) {
  const [state, setState] = useState({
    loading: false,
    isFormValid: false,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    handleFormChange: (_, allFields) => {
      const isFormValid = allFields.every((field) => {
        return field.errors.length === 0 && field.value;
      });
      actions.setState({ isFormValid });
    },

    createAndEnrollStudent: async (values) => {
      actions.setState({ loading: true });
      try {
        const response = await createAndEnrollStudent(
          flowState.class.enrollmentCode,
          {
            firstName: capitalizeAllWords(values.firstName.trim()),
            lastName: capitalizeAllWords(values.lastName.trim()),
            password: values.password,
            classId: flowState.class.id,
          }
        );
        if (response.possibleClassDuplicates) {
          flowActions.setActiveStep('confirmPossibleDuplicate');
          flowActions.setStudentData({
            firstName: values.firstName,
            lastName: values.lastName,
            password: values.password,
            possibleDuplicates: response.possibleClassDuplicates,
          });
        } else {
          flowActions.setCredentials({
            username: response.ssoId,
            password: values.password,
          });
          flowActions.setActiveStep('success');
        }
      } catch (error) {
        console.error('Error creating and enrolling student', error);
        openAPIErrorNotification({
          title: 'There was an error',
          description: 'There was a problem with the enrollment',
          errorFeedback: error.feedbackData,
        });
        actions.setState({
          loading: false,
        });
      }
    },
    goBack: () => {
      flowActions.setActiveStep('selectCreateOrLogin');
    },
  };

  return { state, actions };
}
